import growl from '../services/growl';
import {base_url, EVENTS} from '../services/constants';
import DataStore from '../services/data-store';
import EventBus from '../services/event-bus';
import UrlService from '../services/url-service';

let factory = {
    identity,
    loginShopAsync,
    redirectTo: null,
};
init();
function init() {
	EventBus.$on(EVENTS.requestManagerLogin, () => {
        UrlService.go({ name: "manager-login", params: { next: UrlService.current() } });
    });
}

let managerPromise = null;
async function identity(force = false) {
    if (force) {
        managerPromise = null;
    }
    if (!managerPromise) {
        managerPromise = DataStore.get(base_url + "/admin/manager/identity2", '');
    }
    let data = await managerPromise;
	return data.identity;
}

function loginShopAsync(shop, url, newTab = true) {
    return DataStore.post(base_url + '/admin/manager/login-user', { Email: shop.EmailTrue },'')
    .then((data) => {
        // if (data.isNewLogin) {
        //     return DataStore.post(base_url + '/admin/manager/login-user', { Email: shop.EmailTrue })
        // } else {
            return data;
        // }
    })
    .then(_ => newTab ? window.open(url) : location.href = url)
    .catch((err) => {
        let msg = err.data && err.data.msg || err
        growl.error('Erreur lors du login: ' + msg)
        return Promise.reject(msg);
    })
}

export default factory;